import React, {useState} from "react";
import { Table, Tooltip, notification } from "antd";
import { useTranslation } from "react-i18next";
import Actions from "./Actions";
import green from "../../../../assets/images/green.svg";
import red from "../../../../assets/images/red.svg";
import orange from "../../../../assets/images/orange.svg";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CommonAction from "stores/common/CommonAction";
import { useDispatch } from "react-redux";

const PageTableview = ({ data, handler }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedHistory, setSelectedHistory] = useState(null);
  const pageOptions = useSelector((state) => state.common.options);

  const handleSelectedHistory = (id) => {
    setSelectedHistory(id);
  }
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);
    const options = {
      weekday: "short",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "Europe/Paris",
    };

    // Captialization code
    const weekday = date.toLocaleDateString(t("currentLanguage"), { weekday: "short", timeZone: "Europe/Paris" });
    const month = date.toLocaleDateString(t("currentLanguage"), { month: "short", timeZone: "Europe/Paris" });
    const day = date.toLocaleDateString(t("currentLanguage"), { day: "2-digit", timeZone: "Europe/Paris" });
    const time = date.toLocaleTimeString(t("currentLanguage"), { hour: "2-digit", minute: "2-digit", hour12: true, timeZone: "Europe/Paris" });
    const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);
    return `${capitalize(weekday)} ${day} ${capitalize(month)} ${time}`;

    // Normal Code
    // const formatedDate = date.toLocaleString(t("currentLanguage"), options).replace(/,/g, "");
    // return formatedDate;


  };

  const handleSort = (pagination, filters, sorter) => {
    customSortFunction(sorter);
  };

  const customSortFunction = (sorter) => {
    const { field, order } = sorter;

    let sortOrder;
    let sortField = field;

    if (order === "ascend") {
      sortOrder = "ASC";
    } else if (order === "descend") {
      sortOrder = "DESC";
    } else {
      sortField = field;
      sortOrder = "ASC";
    }
    handler(sortField, sortOrder);
  };

  const handleOnEdit = (documentId, extraction_status) => {
    if (
      extraction_status === "invalid_file_format" ||
      extraction_status === "invalid_pet_invoice" ||
      extraction_status === "extraction_issue"
    ) {
      notification.error({ message: t("notAllowedToEdit") });
    } else {
      
      const position = window.scrollY;
      dispatch(CommonAction.setSelectedDocument(documentId));
      dispatch(CommonAction.setCurrentPosition(position));
      navigate(`/invoice/${documentId}`);
    }
  };

  const translatePageCount = (count) => {
    if (count && count <= 1) {
      return `${count} ${t("page")}`;
    } else if (count && count > 1) {
      return `${count} ${t("pages")}`;
    } else {
      return "";
    }
  };

  const translateStatus = (status) => {
    return t(status);
  };

  const recipientNameHandle = (name) => {
    if (!name || name === "") {
      return "NA";
    }
    let nameParts = name.split(" ");

    if (nameParts.length === 1) {
      let singleNameInitials = nameParts[0].substring(0, 2).toUpperCase();
      return singleNameInitials;
    }

    let firstNameInitial = nameParts[0].charAt(0);
    let lastName = nameParts[1];

    let lastNameInitials =
      lastName.length >= 2 ? lastName.substring(0, 2) : lastName.charAt(0);

    return `${firstNameInitial}${lastNameInitials}`;
  };

  const capitalizeWords = (str) =>
    str
      ? str
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      : "NA";

  const columnsFromResponse = [
    {
      title: t("documentName"),
      dataIndex: "file_name",
      key: "file_name",
      width: 200,
      ellipsis: true,
      render: (text, record) => (
        <>
          <Tooltip title={translateStatus(record.extraction_status)} placement="topLeft">
            <img
              src={
                record.extraction_status === "Good"
                  ? green
                  : record.extraction_status === "invalid_file_format" ||
                    record.extraction_status === "invalid_pet_invoice" ||
                    record.extraction_status === "extraction_issue"
                  ? red
                  : orange
              }
              alt="document_tick"
            />
          </Tooltip>
          <Tooltip title={text} placement="topLeft">
            <span
              id={record.id}  
              className="fs14 white-space-nowrap poppins-medium dark-text cursor-pointer ps-2"
              onClick={() => handleOnEdit(record.id, record.extraction_status)}
            >
              {text}
            </span>
          </Tooltip>
        </>
      ),
      sorter: true,
      sortOrder:
        pageOptions.sortBy === "file_name"
          ? pageOptions.sortOrder === "ASC"
            ? "ascend"
            : "descend"
          : null,
    },
    {
      title: t("operator"),
      dataIndex: "assigned_user",
      key: "assigned_user",
      width: 110,
      ellipsis: true,
      sorter: true,
      sortOrder:
        pageOptions.sortBy === "assigned_user"
          ? pageOptions.sortOrder === "ASC"
            ? "ascend"
            : "descend"
          : null,
      render: (text) => {
        const initials = recipientNameHandle(text);

        if (initials === "Invalid input") {
          return (
            <Tooltip title={text ? text : 'NAN'}>
              <span className="cell-gray fs14 white-space-nowrap cursor-pointer">
                {text}
              </span>
            </Tooltip>
          );
        }

        return (
          <Tooltip title={text}>
            <div className={`${text ? 'round-icon' : 'round-icon-empty font-400 fs14'}`}>{initials}</div>
          </Tooltip>
        );
      },
    },
    {
      title: t("receiverName"),
      dataIndex: "receiver_name",
      key: "receiver_name",
      width: 130,
      ellipsis: true,
      sorter: true,
      sortOrder:
        pageOptions.sortBy === "receiver_name"
          ? pageOptions.sortOrder === "ASC"
            ? "ascend"
            : "descend"
          : null,
      render: (text) => (
        <Tooltip title={text}>
          <span className="cell-gray fs14 white-space-nowrap cursor-pointer">
            {text || 'NA'}
          </span>
        </Tooltip>
      ),
    },
    {
      title: t("extractedAt"),
      dataIndex: "received_at",
      key: "received_at",
      width: 150,
      render: (text) => (
        <span className="cell-gray fs14 white-space-nowrap">
          {formatDate(text)}
        </span>
      ),
      sorter: true,
      sortOrder:
        pageOptions.sortBy === "received_at"
          ? pageOptions.sortOrder === "ASC"
            ? "ascend"
            : "descend"
          : null,
    },
    {
      title: t("lastModified"),
      dataIndex: "last_modified_at",
      key: "last_modified_at",
      width: 150,
      render: (text) => (
        <span className="cell-gray fs14 white-space-nowrap">
          {formatDate(text)}
        </span>
      ),
      sorter: true,
      sortOrder:
        pageOptions.sortBy === "last_modified_at"
          ? pageOptions.sortOrder === "ASC"
            ? "ascend"
            : "descend"
          : null,
    },
    {
      title: t("noOfPages"),
      dataIndex: "number_of_pages",
      key: "number_of_pages",
      width: 120,
      sorter: true,
      sortOrder:
        pageOptions.sortBy === "number_of_pages"
          ? pageOptions.sortOrder === "ASC"
            ? "ascend"
            : "descend"
          : null,
      render: (text) => (
        <span className="cell-gray fs14 white-space-nowrap">
          {translatePageCount(text)}
        </span>
      ),
    },
    {
      title: t("status"),
      dataIndex: "updated_status",
      key: "updated_status",
      width: 120,
      render: (text, record) => (
        <span
          className={
            record.updated_status === "not_yet_started"
              ? `not-started-card`
              : `${record.updated_status}-span`
          }
        >
          {translateStatus(text)}
        </span>
      ),
    },
    {
      title: t("action"),
      key: "action",
      width: 120,
      align: 'left',
      render: (_, record) => <Actions selectedHistory={selectedHistory} handleSelectedHistory={handleSelectedHistory} record={record} />,
    },
  ];

  return (
    <>
      <div className="bg-white extractpdf-cardcontent table-view-content px-0">
        <div className="row p-0 mx-0">
          <Table
            columns={columnsFromResponse}
            dataSource={data}
            pagination={false}
            showSorterTooltip={false}
            scroll={{ x: 1200 }}
            sticky={true}
            onChange={handleSort}
          />
        </div>
      </div>
    </>
  );
};
export default PageTableview;
